import React from 'react';
import { ArrowUpRight, ShieldCheck } from 'lucide-react';
import PageHead from '../components/PageHead';
import { certifications } from '../data/portfolio';

const Credentials = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 pb-8">
      <PageHead eyebrow="Credentials" title="Verified certifications" />

      <p className="text-[16px] text-ink-soft mt-2 mb-12 max-w-2xl leading-relaxed">
        A selection of active credentials across cloud, AI, reliability, agile, and financial operations — each
        independently verifiable.
      </p>

      <div className="grid gap-5 md:grid-cols-2">
        {certifications.map((c, i) => (
          <a
            key={i}
            href={c.link}
            target="_blank"
            rel="noreferrer"
            className="group rounded-xl border border-border p-6 bg-card/40 hover:bg-card/70 hover:border-brand/60 hover:shadow-lg hover:-translate-y-0.5 transition-all flex flex-col"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="w-10 h-10 rounded-lg border border-border flex items-center justify-center text-brand">
                <ShieldCheck size={18} />
              </div>
              <ArrowUpRight
                size={16}
                className="text-ink-mute group-hover:text-brand group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform"
              />
            </div>
            <h3 className="text-[16px] font-medium tracking-tight leading-snug mt-5 group-hover:text-brand transition-colors">
              {c.title}
            </h3>
            <div className="mono uppercase tracking-widest text-[10.5px] text-ink-mute mt-1">{c.issuer}</div>
            <p className="mt-4 text-[13.5px] leading-relaxed text-ink-soft">{c.body}</p>
            <div className="mt-5 pt-4 border-t border-border/60 text-[12px] mono text-ink-mute">Verify credential</div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Credentials;
